import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_of_the_following_topics_are_included_win_the_facs_written_13'

export const dataPointDefinition = {
  retracedId: 'which_of_the_following_topics_are_included_win_the_facs_written_13',
  name: "Which of the following topics are included within the facility's written policies and procedures for suppliers/subcontractors?",
  description:
    'The intent of this question is to understand if and how the facility conducts due diligence along their supply chain (upstream) of their suppliers and subcontractors. \r\r\nResource on due diligence regarding social and labor aspects: "Human rights due diligence is a way for enterprises to proactively manage potential and actual adverse human rights impacts with which they are involved. It involves four core components: (a) Identifying and assessing actual or potential adverse human rights impacts that the enterprise may cause or contribute to through its own activities, or which may be directly linked to its operations, products or services by its business relationships; (b) Integrating findings from impact assessments across relevant company processes and taking appropriate action according to its involvement in the impact; (c) Tracking the effectiveness of measures and processes to address adverse human rights impacts in order to know if they are working; (d) Communicating on how impacts are being addressed and showing stakeholders – in particular affected stakeholders – that there are adequate policies and processes in place." https://www.ohchr.org/EN/Issues/Business/Pages/CorporateHRDueDiligence.aspx',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'DEFINITION_OF_SUPPLIER_WHICH_INCLUDES_SERVICE_PROVIDERS_AND_RAW',
      text: 'Definition of supplier which includes service providers and raw materials suppliers',
      externalIds: [
        {
          id: 'ms-pla-47x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NEW_AND_EXISTING_SUPPLIERS_SUBCONTRACTORS_RISK_ASSESSMENT_TO_DI',
      text: 'NEW and EXISTING suppliers/subcontractors - Risk assessment to differentiate high risk suppliers/subcontractors within the supply chain',
      externalIds: [
        {
          id: 'ms-pla-48x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NEW_SUPPLIERS_SUBCONTRACTORS_INITIAL_SCREENING_BASED_ON_SOCIAL_',
      text: 'NEW suppliers/subcontractors - Initial screening based on social and labor practices / conducting social and labor due diligence ',
      externalIds: [
        {
          id: 'ms-1--15-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'EXISTING_SUPPLIERS_SUBCONTRACTORS_TRAINING_AND_COMMUNICATION_OF',
      text: "EXISTING suppliers/subcontractors - Training and communication of the facility's social and labor procedures",
      externalIds: [
        {
          id: 'ms-1--15-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'EXISTING_SUPPLIERS_SUBCONTRACTORS_MONITORING_SYSTEM_OF_SOCIAL_A',
      text: 'EXISTING suppliers/subcontractors - Monitoring system of social and labor performance/ continued social and labor due diligence ',
      externalIds: [
        {
          id: 'ms-1--15-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'REQUIRING_SUPPLIERS_TO_CONDUCT_SOCIAL_AND_LABOR_DUE_DILIGENCE_O',
      text: 'Requiring suppliers to conduct social and labor due diligence of their supply chains',
      externalIds: [
        {
          id: 'ms-pla-49x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ms-1--15-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ms-1--15-4f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'DEFINITION_OF_SUPPLIER_WHICH_INCLUDES_SERVICE_PROVIDERS_AND_RAW',
                'NEW_AND_EXISTING_SUPPLIERS_SUBCONTRACTORS_RISK_ASSESSMENT_TO_DI',
                'NEW_SUPPLIERS_SUBCONTRACTORS_INITIAL_SCREENING_BASED_ON_SOCIAL_',
                'EXISTING_SUPPLIERS_SUBCONTRACTORS_TRAINING_AND_COMMUNICATION_OF',
                'EXISTING_SUPPLIERS_SUBCONTRACTORS_MONITORING_SYSTEM_OF_SOCIAL_A',
                'REQUIRING_SUPPLIERS_TO_CONDUCT_SOCIAL_AND_LABOR_DUE_DILIGENCE_O',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-pla-46',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 20390,
  sectionId: '2.2.6.10',
  impactArea: 'Policies and Procedures',
  impactAreaId: 'POLICIES_AND_PROCEDURES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
